import { BID_STATUS, BID_STATUS_LABELS } from '../constants';

export const DEPOSIT_ONLY_BID_STATUSES = new Set([
	BID_STATUS.PENDING_DEPOSIT,
	BID_STATUS.DEPOSIT_PAID,
]);

export const getAllowedBidStatusOptions = ({ hasDeposits } = {}) => {
	const entries = Object.entries(BID_STATUS_LABELS);
	const filtered = hasDeposits
		? entries
		: entries.filter(([value]) => !DEPOSIT_ONLY_BID_STATUSES.has(value));
	return filtered.map(([value, label]) => ({ value, label }));
};

export const isDepositOnlyBidStatus = (status) =>
	DEPOSIT_ONLY_BID_STATUSES.has(status);
